import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/plan/view/license.plan.customers.query.gql"
import type {
  LicensePlanCustomersQuery,
  LicensePlanCustomersQueryVariables,
} from "@/v2-backoffice-client/license/plan/view/__types__/license.plan.customers.query"

type Options = QueryHookOptions<
  LicensePlanCustomersQuery,
  LicensePlanCustomersQueryVariables
>

export function useLicensePlanCustomersQuery(options?: Options) {
  return useQuery<
    LicensePlanCustomersQuery,
    LicensePlanCustomersQueryVariables
  >(query, options)
}
